export default "__VITE_ASSET__083119bc__"